import React, { useState } from 'react';

import LayeredPatternsView from './LayeredPatternsView';
import { parsePATFile } from '@av-platform/rendering-core';

// Default SQUARE pattern
const defaultPattern = parsePATFile(
  '*SQUARE,Square\n0, 0.0, 0.0, 25.4, 25.4, 25.4, -25.4\n90, 12.7, 12.7, 25.4, 25.4, 25.4, -25.4'
)?.[0];

// Layered Patterns Viewer Component
const LayeredPatternsViewer = () => {
  const defaultColors = [
    '#000000',
    '#666666',
    '#999999',
    '#CCCCCC',
    '#FF0000',
    '#00FF00',
    '#0000FF',
  ];

  const [layers, setLayers] = useState([{ color: '#000000' }, { color: '#666666' }]);

  const addLayer = () => {
    setLayers([
      ...layers,
      {
        color: defaultColors[layers.length % defaultColors.length],
      },
    ]);
  };

  const removeLayer = (index) => {
    setLayers(layers.filter((_, i) => i !== index));
  };

  const updateLayer = (index, color) => {
    const newLayers = [...layers];
    newLayers[index] = { ...newLayers[index], color };
    setLayers(newLayers);
  };

  const patterns = layers.map((layer) => ({
    pattern: defaultPattern,
    color: layer.color,
  }));

  return (
    <div style={{ padding: '20px' }}>
      <h2>Vrstvené Patterny</h2>
      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={addLayer}
          data-testid="compose-add-layer-btn"
          style={{
            padding: '8px 16px',
            marginBottom: '10px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Přidat vrstvu
        </button>

        {layers.map((layer, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              gap: '10px',
              alignItems: 'center',
              marginBottom: '10px',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
            }}
          >
            <span style={{ minWidth: '80px' }}>Vrstva {index + 1}:</span>
            <input
              type="color"
              value={layer.color}
              onChange={(e) => updateLayer(index, e.target.value)}
              data-testid={`compose-layer-color-${index}`}
              style={{ width: '50px', height: '30px' }}
            />
            <button
              onClick={() => removeLayer(index)}
              data-testid={`compose-remove-layer-${index}`}
              style={{
                padding: '4px 8px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Odstranit
            </button>
          </div>
        ))}
      </div>

      {patterns.length > 0 && <LayeredPatternsView patterns={patterns} />}
    </div>
  );
};

const Compose = () => {
  return (
    <div style={{ padding: '20px' }}>
      {/* <PatternViewer /> */}
      <div style={{ marginTop: '40px' }}>
        <LayeredPatternsViewer />
      </div>
    </div>
  );
};

export default Compose;
